// ** Auth Endpoints
export default {
  baseUrl: process.env.REACT_APP_FRONT_URL ? process.env.REACT_APP_FRONT_URL : 'http://localhost',
  loginEndpoint: '/auth/token',
  registerEndpoint: '/jwt/register',
  refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/jwt/logout',

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'token',
  storageRefreshTokenKeyName: 'refreshToken'
}
